import { render, staticRenderFns } from "./xzz.vue?vue&type=template&id=160fe416&"
import script from "./xzz.vue?vue&type=script&lang=js&"
export * from "./xzz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports